export class CountryInfo {
    country: string;
    count: string;
    product?: string;
    quantity: number;
    /**
     * 
     * @param country
     * @param product
     * @param quantity
     * @param count
     */
    constructor(country: string,count: string,quantity: number,product?: string) {
        this.country = country;
        this.count = count;
        this.quantity = quantity;
        this.product = product;
    }
}